import classNames from 'classnames'
import { i18n } from '@/locale/i18n'
import TabbedContent from '@/components/tabbed-content/TabbedContent'
import { Crevron } from '@/assets/icons'
import {
  BET_TABLE_CLASS,
  BetListActiveTableHeaders,
  BetListOrdersTableHeaders,
} from './BetListTableHeaders'
import BetListTableLoadingBody from './BetListTableLoadingBody'
import TransactionsTimelineSkeleton from './TransactionsTimelineSkeleton'
import './BetList.scss'

const BetListLoadingShell = ({
  openCount = 0,
  transactionsCount = 0,
  ordersCount = 0,
  activeTabIndex = 0,
  orderBookEnabled = false,
  rowCount = 3,
}) => {
  const tabHeaders = [
    i18n('question_card.my_positions'),
    i18n('question_card.my_transactions'),
    i18n('question_card.my_open_orders'),
  ]

  const renderActiveTable = () => (
    <div className="pt-4">
      <table className={BET_TABLE_CLASS}>
        <BetListActiveTableHeaders orderBookEnabled={orderBookEnabled} />
        <tbody>
          <BetListTableLoadingBody rows={Math.max(openCount, rowCount)} activeOrPast="active" columnCount={5} />
        </tbody>
      </table>
    </div>
  )

  // The pad sits outside the scroller: inside it, the sticky day label would
  // leave a strip above itself for rows to scroll through.
  const renderTransactionsTimeline = () => (
    <div className="pt-4">
      <div className="bet-list__scroll">
        <TransactionsTimelineSkeleton rows={rowCount} />
      </div>
    </div>
  )

  const renderOrdersTable = () => (
    <div className="pt-4">
      <table className={BET_TABLE_CLASS}>
        <BetListOrdersTableHeaders />
        <tbody>
          <BetListTableLoadingBody rows={rowCount} activeOrPast="order" />
        </tbody>
      </table>
    </div>
  )

  const tabContents = [
    {
      label: (
        <div className="tab-label">
          {i18n('bet.active')} <span className="bet-count">{openCount}</span>
        </div>
      ),
      render: renderActiveTable,
    },
    {
      label: (
        <div className="tab-label">
          {i18n('bet.transactions')} <span className="bet-count">{transactionsCount}</span>
        </div>
      ),
      render: renderTransactionsTimeline,
    },
    {
      label: (
        <div className="tab-label w-max">
          {i18n('bet.open_orders')} <span className="bet-count">{ordersCount}</span>
        </div>
      ),
      render: renderOrdersTable,
    },
  ]

  return (
    <div
      className={classNames('question-card__section--wide question-card__bet-status bet-list', {
        'mt-4': true,
      })}>
      <div className="bet-list__header flex justify-between items-center gap-4">
        <h4 className="market-h2">{tabHeaders[activeTabIndex] || tabHeaders[0]}</h4>
        {/* Placeholder for the real toggle: a skeleton must not hand the user a
            focusable control that does nothing. */}
        <span aria-hidden className="flex items-center justify-center w-8 h-8">
          <Crevron direction="up" width={16} height={16} fillcolor="var(--color-Neutral-5)" />
        </span>
      </div>
      <div className="rounded-lg pt-4">
        <div className="bet-list__section rounded-lg !overflow-visible">
          <TabbedContent
            activeIndex={activeTabIndex}
            contents={tabContents}
            className="bet-list__tabs"
            defaultIndex={0}
            onContentChange={() => {}}
          />
        </div>
      </div>
    </div>
  )
}

export default BetListLoadingShell
